import React, {useState} from 'react';
import { useParams } from 'react-router';
import {Button, Col, Row, Spinner} from "react-bootstrap";
import styles from './registration-confirmation.module.scss';
import {CurrencyInput, DateInput, FormGroup, TextInput} from "../../../../../components/form/form";
import SecondaryMarketService from "../../../../../services/secondary-market-service";
import {getDeliveryModes, getInvestorCategory, getSettBankList} from "../../../../../helpr/orderFormData";
import {getTaxStatusTypes} from "../../../../../helpr/transferFormData";
import {getOrganizationType} from "../../../../../helpr/registrationFormData";

const RegistrationConfirmation = ({context, controls}) => {
  const [loading, setLoading] = useState(false);
  const [checkboxState, setCheckboxState] = useState(false);
  const {next, back} = controls;
  const { initialRegistrationInfoState, registrationFormState } = context;
  const secondaryMarketService = new SecondaryMarketService();
  //Retrieve security id from params
  const { registrationId }  = useParams();
  const onConfirm = () => {
    setCheckboxState(!checkboxState);
  }
  const submit = async () => {
    setLoading(true);
    try {
      console.log(registrationFormState);
      await secondaryMarketService.submitRegistration(registrationId, registrationFormState);
      setLoading(false);
      next();
    } catch(error) {
      console.log(error.message);
    }
  }

  const renderInvestorCategoryData = () => {
    return registrationFormState.investorCategory.type === 'INDV' ? (
      <>
        <Row>
          <Col lg={6} className={styles['label']}>Nationality</Col>
          <Col lg={6} className={styles['value']}>{registrationFormState.nationality}</Col>
        </Row>
        <Row>
          <Col lg={6} className={styles['label']}>US Resident or US Person</Col>
          <Col lg={6} className={styles['value']}>{registrationFormState.usResident}</Col>
        </Row>
        <Row>
          <Col lg={6} className={styles['label']}>US Citizen</Col>
          <Col lg={6} className={styles['value']}>{registrationFormState.usCitizen}</Col>
        </Row>
        <Row>
          <Col lg={6} className={styles['label']}>US Permanent Resident Card</Col>
          <Col lg={6} className={styles['value']}>{registrationFormState.usResidentCard}</Col>
        </Row>
      </>
    ) : (
      <>
        <Row>
          <Col lg={6} className={styles['label']}>Type of Organization</Col>
          <Col lg={6} className={styles['value']}>{renderOrgTypeValue(registrationFormState.organizationType) ? renderOrgTypeValue(registrationFormState.organizationType) : `Others (${registrationFormState.organizationType})`}</Col>
        </Row>
        <Row>
          <Col lg={6} className={styles['label']}>Name of Parent Organization, if any</Col>
          <Col lg={6} className={styles['value']}>{registrationFormState.parentCompany === '' ? '-' : registrationFormState.parentCompany}</Col>
        </Row>
      </>
    )
  }

  const renderCategoryValue = key => getInvestorCategory().filter(t => t.value === key)[0]?.name;
  const renderDeliveryValue = key => getDeliveryModes().filter(t => t.value === key)[0]?.name;
  const renderTaxStatusValue = key => getTaxStatusTypes().filter(t => t.value === key)[0]?.name;
  const renderBankValue = key => getSettBankList().filter(t => t.value === key)[0]?.name;
  const renderOrgTypeValue = key => getOrganizationType().filter(t => t.value === key)[0]?.name;

  return (
    <div className={styles['form-section']}>
      <Row>
        <Col lg={12}>
          <FormGroup header={'INVESTOR REGISTRATION APPLICATION SUMMARY'}>
            <Row>
              <Col lg={6} className={styles['label']}>Security ID/ISIN No.</Col>
              <Col lg={6} className={styles['value']}>{initialRegistrationInfoState.securityId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Settlement Date</Col>
              <Col lg={6} className={styles['value']}>{initialRegistrationInfoState.settlementDate}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Face Amount</Col>
              <Col lg={6} className={styles['value']}>{initialRegistrationInfoState.faceAmount}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Type of Investor</Col>
              <Col lg={6} className={styles['value']}>
                { renderCategoryValue(registrationFormState.investorCategory.type) }{' '}
                { registrationFormState.investorCategory.type === 'CORP' ? ` (${registrationFormState.investorCategory.under})` : ''}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Investor Name/Business Name</Col>
              <Col lg={6} className={styles['value']}>{registrationFormState.investor}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Date of Birth/Incorporation</Col>
              <Col lg={6} className={styles['value']}>{registrationFormState.dateBirthIncorporation}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Place of Birth/Incorporation</Col>
              <Col lg={6} className={styles['value']}>{registrationFormState.placeBirthIncorporation}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Country of Domicile</Col>
              <Col lg={6} className={styles['value']}>{registrationFormState.domicile}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            { renderInvestorCategoryData() }
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Telephone Number</Col>
              <Col lg={6} className={styles['value']}>{registrationFormState.telNo}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Email Address</Col>
              <Col lg={6} className={styles['value']}>{registrationFormState.emailAddress}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Present Address</Col>
              <Col lg={6} className={styles['value']}>
                {`${registrationFormState.presentAddress.streetAddress} ${registrationFormState.presentAddress.districtOrTown} 
                ${registrationFormState.presentAddress.city} ${registrationFormState.presentAddress.stateProvinceRegion}
                ${registrationFormState.presentAddress.country} ${registrationFormState.presentAddress.zipCode}`}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Permanent Address</Col>
              <Col lg={6} className={styles['value']}>
                {`${registrationFormState.permanentAddress.streetAddress} ${registrationFormState.permanentAddress.districtOrTown} 
                ${registrationFormState.permanentAddress.city} ${registrationFormState.permanentAddress.stateProvinceRegion}
                ${registrationFormState.permanentAddress.country} ${registrationFormState.permanentAddress.zipCode}`}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Mailing Address</Col>
              <Col lg={6} className={styles['value']}>
                {`${registrationFormState.mailingAddress.streetAddress} ${registrationFormState.mailingAddress.districtOrTown} 
                ${registrationFormState.mailingAddress.city} ${registrationFormState.mailingAddress.stateProvinceRegion}
                ${registrationFormState.mailingAddress.country} ${registrationFormState.mailingAddress.zipCode}`}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Delivery Mode</Col>
              <Col lg={6} className={styles['value']}>{renderDeliveryValue(registrationFormState.statementDeliveryMode)}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Primary Contact Name</Col>
              <Col lg={6} className={styles['value']}>
                {`${registrationFormState.primaryContact.salutation} ${registrationFormState.primaryContact.firstName}
                ${registrationFormState.primaryContact.middleName} ${registrationFormState.primaryContact.lastName}`}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Primary Contact Telephone Number</Col>
              <Col lg={6} className={styles['value']}>
                {registrationFormState.primaryContactTelNo}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Primary Contact Email Address</Col>
              <Col lg={6} className={styles['value']}>
                {registrationFormState.primaryContactEmailAddress}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Occupation/Nature of Business</Col>
              <Col lg={6} className={styles['value']}>
                {registrationFormState.nature}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Souce of Income</Col>
              <Col lg={6} className={styles['value']}>
                {registrationFormState.incomeSource ? registrationFormState.incomeSource.join(', ') : '-'}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>TIN</Col>
              <Col lg={6} className={styles['value']}>
                {registrationFormState.tin}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Tax Status</Col>
              <Col lg={6} className={styles['value']}>
                {renderTaxStatusValue(registrationFormState.taxStatus)}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Current/Savings Account Number</Col>
              <Col lg={6} className={styles['value']}>
                {registrationFormState.accountNumber}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Bank Name</Col>
              <Col lg={6} className={styles['value']}>
                {renderBankValue(registrationFormState.bankName)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Bank Branch</Col>
              <Col lg={6} className={styles['value']}>
                {registrationFormState.bankBranch}
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <FormGroup header={'INVESTOR/CLIENT CONFIRMATION'}>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                  <span className={styles['sub-label']}>
                    I/We  declare under penalty of law that the information  contained  herein(including  tax status) are true,  complete,current, and correct and that the signatures herein are genuine,properly authorized, and obtained without use of fraud, coercion or any other vice of consent. I/We acknowledge and accept that PDTC shall rely solely on the information provided herein including, without limit, its declaration of its tax status, including, if applicable, its tax-exempt status in processing payments due it. I/We certify that we have been provided with the Risk Disclosure Statement and have read and understood the terms and conditions of the Tier1/2 issuance and are aware of the risks associated with the said Tier1/2 Notes. I/We hereby authorize PDTC to verify  the information I/we stated in this Registration Form from any and all sources and in any and all manner,including  but not limited to,requesting for information from the introducing entity regarding my accounts with said  entity.   By giving this authority to  PDTC,  I/we  hereby waive  our right toprivacy of information or confidentiality that may  exist  by law or  by  contract with respect the information contained herein. I/WE FURTHER CONFIRM THAT WE HAVE RECEIVED AND UNDERSTOOD THE RULES AND PROCEDURES OF THE REGISTRAR, AND THE RELEVANT INFORMATION ON THE SECURITY INDICATED BELOW, AND WE AGREE TO BE BOUND BY THEM
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <input type="checkbox" onChange={onConfirm}/>
                {' '}
                I confirm.
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['back-button']}>
            <Button variant="secondary" onClick={() => back()}>
              BACK
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button disabled={loading || !checkboxState} onClick={() => submit()}>
              {loading ? <Spinner size="sm" animation="border"/> : 'SUBMIT'}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default RegistrationConfirmation;
